import { render, staticRenderFns } from "./AppMovableDialogContainer.vue?vue&type=template&id=156a2661"
import script from "./AppMovableDialogContainer.vue?vue&type=script&lang=js"
export * from "./AppMovableDialogContainer.vue?vue&type=script&lang=js"
import style0 from "./AppMovableDialogContainer.vue?vue&type=style&index=0&id=156a2661&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports